export default __webpack_public_path__ + "images/assets/b4595d6b4f1d8c41165a1076f97200b0.svg";